import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-176e00bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fields"
}
const _hoisted_2 = { class: "smaller-fields" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "offer-description" }, " All offers related to this contact and property: ", -1))
const _hoisted_4 = {
  key: 0,
  class: "fields"
}
const _hoisted_5 = { class: "row-fields-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = { class: "row-fields-3" }
const _hoisted_8 = {
  key: 0,
  class: "fields smaller-fields"
}

import { computed, ref, watch, onMounted } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { DxToolbarItem } from "devextreme-vue/popup";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import AcquaintDateBox from "@/components/ui/inputs/acquaint-date-box.vue";
import { OfferData } from "@/types/OfferData";
import AcquaintTextArea from "@/components/ui/inputs/acquaint-text-area.vue";
import CurrencyInput from "@/components/ui/inputs/currency-input.vue";
import { CodeType } from "acquaint-api/constants/CodeType";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import ContactLookup from "@/components/ui/lookup/contact-lookup.vue";
import PropertyLookup from "@/components/ui/lookup/property-lookup.vue";
import { PropertyOffersValidation } from "acquaint-api/validation/PropertyOffersValidation";
import { FieldSize } from "@/enums/system/FieldSize";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import moment from "moment";
import { Contacts } from "acquaint-api/models/Contacts";
import ContactsPeekPopup from "@/components/contacts/contacts-peek-popup.vue";
import { ValidatedEvent } from "devextreme/ui/validator";
import { TimeStamps } from "@/utils/TimeStamp";
import { useUserPermissionsStore } from "@/stores/UserPermissionsStore";
import { UserPermissions } from "@/types/user/permissions/UserPermissions";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import SendOffersModal from "@/components/offers/send-offers-modal.vue";
import { PropertySummary } from "@/types/properties/PropertySummary";
import { usePropertyOfferHelper } from "@/utils/properties/usePropertyOfferHelper";
import { usePropertyHelper } from "@/utils/properties/usePropertyHelper";
import { useContactHelper } from "@/utils/contacts/useContactHelper";
import { RealtedOfferItem } from "@/types/offers/RelatedOfferItem";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import RelatedOffersGrid from "@/components/offers/related-offers-grid.vue";
import { useScreenHelper } from "@/utils/system/ScreenHelper";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { PropertyCategory } from "acquaint-api/constants/PropertyCategory";
import { PropertyOfferStatus } from "acquaint-api/constants/PropertyOfferStatus";
import { Properties } from "acquaint-api/models/Properties";
import DateToggle from "@/components/ui/toggles/date-toggle.vue";
import { noDate } from "@/utils/DateCalculator";
import { PropertyCompletionDateStatus } from "@/enums/property-offers/OfferStatus";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-offers-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the offer.
   * @type {number}
   * @default 0
   */
  offerId: {
    type: Number,
    required: true,
  },
  /**
   * The unique identifier for the contact.
   * @type {number}
   * @default 0
   */
  contactId: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the property.
   * @type {number}
   * @default 0
   */
  propertyId: {
    type: Number,
    default: 0,
  },
  /**
   * Indicates whether control includes time.
   * @type {boolean}
   * @default true
   */
  includeTime: {
    type: Boolean,
    default: true,
  },
  /**
   * Indicates whether or not the modal is a new offer. When the data is saved, this is used in a check to determine whether or not the send offer modal is displayed.
   * @type {boolean}
   * @default false
   */
  newOffer: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when the modal is closed.
   * Notifies the parent component whether data should be updated.
   * @property {boolean} - Indicates if the data needs to be refreshed after closing.
   */
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





const { isMobile } = useScreenHelper();
const contactHelper = useContactHelper();
const propertyHelper = usePropertyHelper();
const propertyOfferHelper = usePropertyOfferHelper();
const displayCancelConfirmationModal = ref(false);
const keepingModalOpening = ref(false);
const saving = ref(false);
const editableOffer = ref<OfferData>();
const originalOffer = ref<OfferData>();
const dataApiCallFailed = ref(false);
const addedByUser = ref<Contacts>();
const showAddedByPeek = ref(false);
const selectedTabPanel = ref(0);
const propertyLookupKey = ref(0);
const contactIsRequired = ref(false);
const focusNoteField = ref(false);
const userPermissionsStore = useUserPermissionsStore();
const userPermissions = ref<UserPermissions>();
const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const readOnly = ref(false);
const systemConfigurationStore = useSystemConfigurationStore();
const displaySendOfferModal = ref(false);
const propertySummaryData = ref<PropertySummary>();
const relateOfferList = ref<RealtedOfferItem[]>();
const loading = ref(false);
const showTabProgression = ref(false);
const propertyData = ref<Properties>();
const mintPreviousStatus = ref(-1);

const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
  userPermissions.value = await userPermissionsStore.getUserPermissions();
});

const onCancelClick = () => (showModal.value = false);

watch(
  () => showModal.value,
  async () => {
    if (
      !showModal.value ||
      keepingModalOpening.value ||
      !userPermissions.value
    ) {
      return;
    }
    loading.value = true;
    contactIsRequired.value = false;

    selectedTabPanel.value = 0;

    dataApiCallFailed.value = false;

    if (props.offerId == 0) {
      await fetchDefaultData();
    } else {
      await fetchOfferData();
    }

    mintPreviousStatus.value = editableOffer.value?.status ?? -1;
    if (dataApiCallFailed.value) {
      originalOffer.value = undefined;
      editableOffer.value = undefined;
      return;
    }

    if (!originalOffer.value) {
      return;
    }

    if (props.contactId > 0) {
      originalOffer.value.contactID = props.contactId;
    }

    if (props.propertyId > 0) {
      originalOffer.value.propertyID = props.propertyId;
    }

    relateOfferList.value = await propertyOfferHelper.loadRelatedOffers(
      props.contactId,
      originalOffer.value.propertyID,
    );

    const propertyItem = await propertyHelper.fetchPropertyById(
      originalOffer.value.propertyID,
    );

    if (propertyItem) {
      propertyData.value = propertyItem;
      if (propertyItem.category === PropertyCategory.ForSale) {
        showTabProgression.value = true;
      } else {
        showTabProgression.value = false;
      }
    }

    editableOffer.value = JSON.parse(JSON.stringify(originalOffer.value));
    propertyLookupKey.value++;
    await fetchAddedByUser();

    if (!userPermissions.value.correspondence.edit) {
      readOnly.value = true;
    } else {
      readOnly.value = false;
    }

    loading.value = false;
  },
);

watch(
  () => editableOffer.value,
  () => {
    displayCancelConfirmationModal.value =
      JSON.stringify(editableOffer.value) !=
      JSON.stringify(originalOffer.value);
  },
  { deep: true },
);

const modalClosed = async () => {
  // Release lock
  await propertyOfferHelper.lockOffer(props.offerId, false);
  keepingModalOpening.value = false;
  displayCancelConfirmationModal.value = false;
  emit("modalClosed", false);
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const editOffer = async () => {
  try {
    if (editableOffer.value) {
      const newItem = await propertyOfferHelper.editOffer(
        props.offerId,
        editableOffer.value,
      );
      if (newItem) {
        editableOffer.value = { ...newItem };
      }
      return true;
    }
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const createOffer = async () => {
  try {
    if (editableOffer.value) {
      const newItem = await propertyOfferHelper.createOffer(
        editableOffer.value,
      );
      if (newItem) {
        editableOffer.value = { ...newItem };
      }
      return true;
    }
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const fetchOfferData = async () => {
  try {
    const item = await propertyOfferHelper.fetchOfferData(props.offerId);
    if (item) {
      originalOffer.value = { ...item };
    }
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    dataApiCallFailed.value = true;
  }
};

const fetchDefaultData = async () => {
  try {
    const item = await propertyOfferHelper.fetchDefaultData();
    if (item) {
      originalOffer.value = { ...item };
    }
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    dataApiCallFailed.value = true;
  }
};

const onSaveClick = async (e: any) => {
  try {
    contactIsRequired.value = true;
    const validation: ValidatedEvent = e.validationGroup.validate();

    if (!validation.isValid) {
      return;
    }

    saving.value = true;

    if (props.offerId == 0) {
      if (!(await createOffer())) {
        saving.value = false;
        return;
      }
    } else {
      if (!(await editOffer())) {
        saving.value = false;
        return;
      }
    }

    // Check if offer status has changed
    const VALID_OFFER_STATUSES = [
      PropertyOfferStatus.Pending,
      PropertyOfferStatus.Accepted,
      PropertyOfferStatus.Rejected,
      PropertyOfferStatus.Withdrawn,
      PropertyOfferStatus.AwaitingProof,
    ];

    const offer = editableOffer.value;
    const hasValidStatus = offer && VALID_OFFER_STATUSES.includes(offer.status);

    if (
      offer &&
      (props.offerId === 0 || mintPreviousStatus.value !== offer?.status) &&
      hasValidStatus
    ) {
      //  Check if we're suppressing prompt before showing it (ACRM-5943 JK 16/07/2020)
      const val = await systemConfigurationStore.getSystemConfigurationValue(
        SystemConfiguration.SuppressSendPropertyOffersPrompt,
      );
      if (Number(val) == 0) {
        //  Status changed - ask user if they'd like to inform relevant parties (ACRM-1425 JK 16/04/2020)
        const sendOffer = await displayQuestionAlert(
          "Would you like to send this Offer to the relevant parties?",
        );

        if (sendOffer.isConfirmed) {
          await fetchPropertyDataSummary();
          if (!propertySummaryData.value) {
            return;
          }
          displaySendOfferModal.value = true;
        }
      }
    }

    displayCancelConfirmationModal.value = false;
    emit("modalClosed", true);
    showModal.value = false;
    saving.value = false;
  } catch (error) {
    displayErrorMessage(getErrorMessage(error));
  }
};

const fetchPropertyDataSummary = async () => {
  try {
    const summaryItem = await propertyHelper.fetchPropertyDataSummary(
      editableOffer.value?.propertyID ?? 0,
    );
    if (summaryItem) {
      propertySummaryData.value = { ...summaryItem };
    }
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    propertySummaryData.value = undefined;
  }
};

const formattedDateUpdated = computed(() =>
  moment(editableOffer.value?.updatedDate).format("DD/MM/YYYY"),
);
const formattedStatusChanged = computed(() =>
  moment(editableOffer.value?.statusDate).format("DD/MM/YYYY"),
);

const fetchAddedByUser = async () => {
  if (!editableOffer.value?.userID) {
    return undefined;
  }

  try {
    const contactItem = await contactHelper.fetchContactById(
      editableOffer.value.userID,
    );
    if (contactItem) {
      addedByUser.value = { ...contactItem };
    }
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    addedByUser.value = undefined;
  }
};

const addedByName = computed(() =>
  addedByUser.value
    ? `${addedByUser.value.firstNames} ${addedByUser.value.lastName}`
    : "",
);

// We must update selectedTabPanel everytime a user changes which tab they're on so that when the modal is reopened
// we can set it to 0, thus taking them back to first tab. If selectedTabPanel is to 0 when the modal is opened
// after this has been removed, nothing will happen.
const selectChange = (e: any) => {
  switch (e.addedItems[0].title) {
    case "Details":
      selectedTabPanel.value = 0;
      break;
    case "Related Offers":
      selectedTabPanel.value = 1;
      break;
    case "Progression":
      selectedTabPanel.value = 2;
      break;
    case "System Info":
      {
        if (showTabProgression.value) {
          selectedTabPanel.value = 3;
        } else {
          selectedTabPanel.value = 2;
        }
      }
      break;
  }
};

const showContactPeek = () => {
  showAddedByPeek.value = true;
};

/** Adds a date stamp to the end of the current taskbody */
const dateStamp = async () => {
  if (!editableOffer.value) {
    return;
  }

  editableOffer.value.notes = await TimeStamps(editableOffer.value.notes);
  focusNoteField.value = true;

  setTimeout(() => {
    focusNoteField.value = false;
  }, 50);
};

const showCompletionDateStatus = computed(() => {
  return !noDate(editableOffer.value?.completionDate);
});

const helpPage = computed(() =>
  props.offerId ? "property-offers" : "adding-an-offer",
);

const propertyLookupReadOnly = computed(() => {
  return readOnly.value || props.propertyId > 0;
});

const contactLookupReadOnly = computed(() => {
  return readOnly.value || props.contactId > 0;
});

const gridHeight = computed(() => {
  return isMobile.value ? "" : `height: 360px;`;
});

const loadRelatedOffers = async () => {
  relateOfferList.value = await propertyOfferHelper.loadRelatedOffers(
    editableOffer.value?.contactID ?? 0,
    editableOffer.value?.propertyID ?? 0,
  );
};

const onPropertyChange = async () => {
  await loadRelatedOffers();
};

const onContactChange = async () => {
  await loadRelatedOffers();
};

const onStatueChange = async () => {
  // For sales properties default completion date if required
  if (
    propertyData.value &&
    editableOffer.value &&
    propertyData.value.category === PropertyCategory.ForSale
  ) {
    // Only do this for accepted offers where no completion date has been set
    if (
      mintPreviousStatus.value !== editableOffer.value.status &&
      editableOffer.value.status === PropertyOfferStatus.Accepted &&
      noDate(editableOffer.value.completionDate)
    ) {
      // Read system config for number of weeks
      const val = await systemConfigurationStore.getSystemConfigurationValue(
        SystemConfiguration.EstimatedCompletionDateAfterAcceptedOffer,
      );

      // Only continue if system config option isn't set to 0
      if (parseInt(val) > 0) {
        editableOffer.value.completionDate = moment()
          .add(parseInt(val) * 7, "d")
          .format("YYYY-MM-DD");
        editableOffer.value.completionDateStatus =
          PropertyCompletionDateStatus.Estimate;
      }
    }
  }
};

const onSolicitorChange = () => {
  editableOffer.value &&= {
    ...editableOffer.value,
    solicitorID: Math.max(0, editableOffer.value.solicitorID),
  };
};

const onBrokerChange = () => {
  editableOffer.value &&= {
    ...editableOffer.value,
    mortgageBrokerID: Math.max(0, editableOffer.value.mortgageBrokerID),
  };
};

const onProviderChange = () => {
  editableOffer.value &&= {
    ...editableOffer.value,
    mortgageProviderID: Math.max(0, editableOffer.value.mortgageProviderID),
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((showModal).value = $event)),
      title: "Property Offer",
      onCancelPromptDenied: cancelPromptDenied,
      onModalClosed: modalClosed,
      showCloseConfirmationPrompt: displayCancelConfirmationModal.value,
      height: "550px",
      "help-page": helpPage.value,
      width: _unref(ModalWidth).Medium
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(DxTabPanel), {
          selectedIndex: selectedTabPanel.value,
          onSelectionChanged: selectChange
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DxItem), { title: "Details" }, {
              default: _withCtx(() => [
                (editableOffer.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                      (_openBlock(), _createBlock(PropertyLookup, {
                        label: "Property",
                        modelValue: editableOffer.value.propertyID,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((editableOffer.value.propertyID) = $event)),
                          onPropertyChange
                        ],
                        onNavigateToProperty: _cache[1] || (_cache[1] = ($event: any) => (emit('modalClosed', false))),
                        "read-only": propertyLookupReadOnly.value,
                        required: true,
                        key: propertyLookupKey.value,
                        displayNavigateIcon: props.propertyId == 0
                      }, null, 8, ["modelValue", "read-only", "displayNavigateIcon"])),
                      _createVNode(ContactLookup, {
                        label: "Contact",
                        modelValue: editableOffer.value.contactID,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((editableOffer.value.contactID) = $event)),
                          onContactChange
                        ],
                        "read-only": contactLookupReadOnly.value,
                        findNameOnIdChange: true,
                        onNavigateToContact: _cache[3] || (_cache[3] = ($event: any) => (emit('modalClosed', false))),
                        isRequired: contactIsRequired.value,
                        showNavigateContactIcon: props.contactId == 0
                      }, null, 8, ["modelValue", "read-only", "isRequired", "showNavigateContactIcon"]),
                      _createVNode(AcquaintTextArea, {
                        label: "Notes",
                        modelValue: editableOffer.value.notes,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editableOffer.value.notes) = $event)),
                        fieldValidation: _unref(PropertyOffersValidation).Notes,
                        focusInput: focusNoteField.value,
                        readOnly: readOnly.value,
                        "validation-group": "edit-offers-modal"
                      }, null, 8, ["modelValue", "fieldValidation", "focusInput", "readOnly"]),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(AcquaintDateBox, {
                          label: "Offer Date",
                          modelValue: editableOffer.value.offerDate,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editableOffer.value.offerDate) = $event)),
                          fieldValidation: _unref(PropertyOffersValidation).OfferDate,
                          width: _unref(FieldSize).Medium,
                          includeTime: props.includeTime,
                          readOnly: readOnly.value,
                          "validation-group": "edit-offers-modal"
                        }, null, 8, ["modelValue", "fieldValidation", "width", "includeTime", "readOnly"]),
                        _createVNode(CurrencyInput, {
                          label: "Amount",
                          modelValue: editableOffer.value.amount,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editableOffer.value.amount) = $event)),
                          width: _unref(FieldSize).Medium,
                          "max-value": 9999999999,
                          readOnly: readOnly.value
                        }, null, 8, ["modelValue", "width", "readOnly"]),
                        _createVNode(SystemCodeSingleSelect, {
                          label: "Status",
                          modelValue: editableOffer.value.status,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editableOffer.value.status) = $event)),
                          "code-type": _unref(CodeType).PropertyOfferStatus,
                          width: _unref(FieldSize).Medium,
                          readOnly: readOnly.value,
                          onValueChanged: onStatueChange
                        }, null, 8, ["modelValue", "code-type", "width", "readOnly"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Related Offers" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle(gridHeight.value)
                }, [
                  _hoisted_3,
                  _createVNode(RelatedOffersGrid, {
                    relateOfferList: relateOfferList.value ?? [],
                    loading: loading.value,
                    "country-code": currentUser.value?.countryCodeID
                  }, null, 8, ["relateOfferList", "loading", "country-code"])
                ], 4)
              ]),
              _: 1
            }),
            (showTabProgression.value)
              ? (_openBlock(), _createBlock(_unref(DxItem), {
                  key: 0,
                  title: "Progression"
                }, {
                  default: _withCtx(() => [
                    (editableOffer.value)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                          _createVNode(LookupSingleSelect, {
                            "lookup-source": _unref(LookupTableSource).Solicitors,
                            modelValue: editableOffer.value.solicitorID,
                            "onUpdate:modelValue": [
                              _cache[8] || (_cache[8] = ($event: any) => ((editableOffer.value.solicitorID) = $event)),
                              onSolicitorChange
                            ],
                            label: "Solicitor",
                            "read-only": false,
                            showSearch: true,
                            showClearButton: true,
                            displayPeek: true
                          }, null, 8, ["lookup-source", "modelValue"]),
                          _createVNode(LookupSingleSelect, {
                            "lookup-source": _unref(LookupTableSource).MortgageProviders,
                            modelValue: editableOffer.value.mortgageBrokerID,
                            "onUpdate:modelValue": [
                              _cache[9] || (_cache[9] = ($event: any) => ((editableOffer.value.mortgageBrokerID) = $event)),
                              onBrokerChange
                            ],
                            label: "Mortgage Broker",
                            "read-only": false,
                            showSearch: true,
                            showClearButton: true,
                            displayPeek: true
                          }, null, 8, ["lookup-source", "modelValue"]),
                          _createVNode(LookupSingleSelect, {
                            "lookup-source": _unref(LookupTableSource).MortgageProviders,
                            modelValue: editableOffer.value.mortgageProviderID,
                            "onUpdate:modelValue": [
                              _cache[10] || (_cache[10] = ($event: any) => ((editableOffer.value.mortgageProviderID) = $event)),
                              onProviderChange
                            ],
                            label: "Mortgage Provider",
                            "read-only": false,
                            showSearch: true,
                            showClearButton: true,
                            displayPeek: true
                          }, null, 8, ["lookup-source", "modelValue"]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(DateToggle, {
                              modelValue: editableOffer.value.mortgageFormSubmitted,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editableOffer.value.mortgageFormSubmitted) = $event)),
                              label: "Mortgage Form Submitted",
                              fieldValidation: 
                  _unref(PropertyOffersValidation).MortgageFormSubmitted
                ,
                              readOnly: false,
                              hideDateField: true
                            }, null, 8, ["modelValue", "fieldValidation"]),
                            _createVNode(DateToggle, {
                              modelValue: editableOffer.value.mortgageOfferReceived,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editableOffer.value.mortgageOfferReceived) = $event)),
                              label: "Mortgage Offer",
                              fieldValidation: 
                  _unref(PropertyOffersValidation).MortgageOfferReceived
                ,
                              readOnly: false,
                              hideDateField: true
                            }, null, 8, ["modelValue", "fieldValidation"]),
                            _hoisted_6
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(CurrencyInput, {
                              modelValue: editableOffer.value.mortgageAmount,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editableOffer.value.mortgageAmount) = $event)),
                              label: "Mortgage Amount",
                              readOnly: false
                            }, null, 8, ["modelValue"]),
                            _createVNode(DateToggle, {
                              modelValue: editableOffer.value.completionDate,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editableOffer.value.completionDate) = $event)),
                              label: "Completion Date",
                              fieldValidation: _unref(PropertyOffersValidation).CompletionDate,
                              readOnly: false,
                              hideDateField: true
                            }, null, 8, ["modelValue", "fieldValidation"]),
                            (showCompletionDateStatus.value)
                              ? (_openBlock(), _createBlock(SystemCodeSingleSelect, {
                                  key: 0,
                                  label: " ",
                                  modelValue: editableOffer.value.completionDateStatus,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((editableOffer.value.completionDateStatus) = $event)),
                                  "code-type": _unref(CodeType).PropertyCompletionDateStatus,
                                  readOnly: false
                                }, null, 8, ["modelValue", "code-type"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(DxItem), { title: "System Info" }, {
              default: _withCtx(() => [
                (editableOffer.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                      _createVNode(AcquaintInfoBox, {
                        text: editableOffer.value.id.toString(),
                        width: _unref(FieldSize).Medium,
                        label: "ID"
                      }, null, 8, ["text", "width"]),
                      _createVNode(AcquaintInfoBox, {
                        text: addedByName.value,
                        width: _unref(FieldSize).Medium,
                        label: "Added By",
                        icon: "fas fa-eye",
                        onIconClicked: showContactPeek
                      }, null, 8, ["text", "width"]),
                      _createVNode(AcquaintInfoBox, {
                        text: formattedDateUpdated.value,
                        width: _unref(FieldSize).Medium,
                        label: "Date Updated"
                      }, null, 8, ["text", "width"]),
                      _createVNode(AcquaintInfoBox, {
                        text: formattedStatusChanged.value,
                        width: _unref(FieldSize).Medium,
                        label: "Status Changed"
                      }, null, 8, ["text", "width"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["selectedIndex"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Date Stamp',
          disabled: saving.value,
          onClick: (e) => {
            dateStamp();
          },
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Save',
          onClick: (e) => {
            onSaveClick(e);
          },
          disabled: saving.value || readOnly.value,
          validationGroup: 'edit-offers-modal',
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
          disabled: saving.value,
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "showCloseConfirmationPrompt", "help-page", "width"]),
    (editableOffer.value && addedByName.value)
      ? (_openBlock(), _createBlock(ContactsPeekPopup, {
          key: 0,
          modelValue: showAddedByPeek.value,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((showAddedByPeek).value = $event)),
          contactId: editableOffer.value.userID,
          title: addedByName.value
        }, null, 8, ["modelValue", "contactId", "title"]))
      : _createCommentVNode("", true),
    (editableOffer.value && propertySummaryData.value)
      ? (_openBlock(), _createBlock(SendOffersModal, {
          key: 1,
          modelValue: displaySendOfferModal.value,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((displaySendOfferModal).value = $event)),
          id: editableOffer.value.id,
          "property-category": propertySummaryData.value.category.id,
          offerStatus: editableOffer.value.status
        }, null, 8, ["modelValue", "id", "property-category", "offerStatus"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})